var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategorySkillsTagsSelectedSideNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4144 8.99463L11.1722 0.752441C10.8206 0.400879 10.3519 0.166504 9.84407 0.166504H1.87532C0.820637 0.166504 0.000324249 1.02588 0.000324249 2.0415V10.0493C0.000324249 10.5571 0.195637 11.0259 0.547199 11.3774L8.78939 19.6196C9.53157 20.3618 10.7425 20.3618 11.4456 19.6196L19.4144 11.6509C20.1566 10.9478 20.1566 9.73682 19.4144 8.99463ZM10.1175 18.2915L1.87532 10.0493V2.0415H9.84407L18.1253 10.3228L10.1175 18.2915ZM7.50032 5.7915C7.50032 4.77588 6.64095 3.9165 5.62532 3.9165C4.57064 3.9165 3.75032 4.77588 3.75032 5.7915C3.75032 6.84619 4.57064 7.6665 5.62532 7.6665C6.64095 7.6665 7.50032 6.84619 7.50032 5.7915Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategorySkillsTagsSelectedSideNav);
export default __webpack_public_path__ + "static/media/category-skills-tags-selected-side-nav.7d8d0c081cab6cd63c1aec4ed4e6824a.svg";
export { ForwardRef as ReactComponent };